var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wcity"},[_c('p',[_vm._v("本服务由云南合道康成信息技术有限公司提供技术支持")])])])
}]

export { render, staticRenderFns }